import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const DropdownComponent = React.lazy(() => import("../Components/RootComponents/DropdownComponent"));
const DropdownPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <DropdownComponent />
      </Suspense>
    </Fragment>
  );
};

export default DropdownPage;
